import { Const } from '@blcloud/bl-common';

/**
 * ページURLパス定義
 */
export const PagePath = {
  // --------------------------------------------------------------------------
  // spa-menu

  /** 車両検索 */
  CustomerVehicleSearch: 'vehicle/search',
  /** 顧客入力 */
  CustomerEntry: 'customer/entry',
  /** 車両入力 */
  VehicleEntry: 'vehicle/entry',
  /** 顧客照会 */
  CustomerInquiry: 'customerinquiry',
  /** 受付 */
  Reception: 'reception/entry',
  /** 履歴 */
  History: 'salesslip/history',
  /** 履歴検索 */
  HistorySearch: 'salesslip/history/search',
  /** プロフィール登録一覧 */
  ProfileEntries: 'profile/entries',
  /** 予約管理 */
  Reserve: 'reserve/entry',
  /** 顧客一括編集 */
  CustomerBulkEdit: 'bulkedit/customer',
  /** 車両一括編集 */
  VehicleBulkEdit: 'bulkedit/vehicle',
  /** SNSフォロワー一覧 */
  SnsFollowerSearch: 'follower/search',
  /** 伝票検索 */
  SlipSearch: 'salesslip/search',

  // --------------------------------------------------------------------------
  // sf-app

  /** 伝票作成 */
  SlipEntry: '/sf/sf-salesslip/entry/slip',
  /** 代車登録 */
  LoanerVehicleEntry: '/sf/loanervehicle/entry',

  // --------------------------------------------------------------------------
  // vehicleapply-app

  /** 申請書類 */
  VehicleApplyEntry: '/vehicleapply/entry',
  /** 保適交付簿 */
  VehicleApplySafetyStdConfIssBook: '/vehicleapply/safetystdconfissbook',
  /** OSS申請状況 */
  VehicleApplyOssApplyStCheck: '/vehicleapply/ossapplystcheck',
  /** OSS納付状況 */
  VehicleApplyOssPaymentStatus: '/vehicleapply/osspaymentstatus',

  // --------------------------------------------------------------------------
  // vehiclerecord-app

  /** 記録簿発行（受付） */
  RecordBookReception: '/vehiclerecord/book/reception',
  /** 事前点検 */
  PreCheck: '/vehiclerecord/precheck',

  // --------------------------------------------------------------------------
  // credit-app

  /** 入金登録 */
  DepositEntry: '/credit/deposit/entry',
  /** 顧客元帳 */
  CustomerLedger: '/credit/customer-ledger',

  // --------------------------------------------------------------------------
  // repair-app

  /** 鈑金伝票作成 */
  RepairSlipEntry: '/repair/salesslip/entry/',
  /** 鈑金見積条件 */
  RepairSlipEntryCondition: '/repair/salesslip/entry/condition',

  // --------------------------------------------------------------------------
  // pm-app

  /** 売上伝票入力 */
  PmSalesSlipEntry: '/pm/pm-salesslip/entry/slip',

  // --------------------------------------------------------------------------
  // carsales-app

  /** 車販伝票入力 */
  CarSalesSlipEntry: '/carsales/salesslip/entry',

  // --------------------------------------------------------------------------
  // approach-app

  /** DM抽出 */
  ApproachSearch: `${Const.SpaRoot.DM}/search`,
  /** SNS一斉送信履歴 */
  ApproachSnsSendHistory: `${Const.SpaRoot.DM}/sns/sendHistory`,

  // --------------------------------------------------------------------------
  // crm

  /** 架電リスト */
  CallingListPage: `${Const.RoutePath.CONTACT}/callList`,
  /** コンタクト一覧 */
  ContactListPage: `${Const.RoutePath.CONTACT}/contactList`,
  /** コンタクトカレンダー */
  ContactCalendarPage: `${Const.RoutePath.CONTACT}/contactCalendar`,
  /** 架電一覧 */
  CallListPage: `${Const.RoutePath.CONTACT}/callList`,

  // --------------------------------------------------------------------------
  // lease-app

  /** 受託リース契約検索 */
  EntrustedVehicldeSearch: '/lease/search',
  // --------------------------------------------------------------------------
  // order-app

  /** 部品検索画面 */
  PartsOrder: '/order/search',

  // --------------------------------------------------------------------------
  // stock-app

  /** 在庫登録画面 */
  VehicleStockEntry: '/stock/vehiclestock/entry',
};



// WEBPACK FOOTER //
// ./src/app/core/const/page-path.const.ts